import { FC } from "react";
import abuseImg from "../../../images/abuse-illus.png";
import { useTranslation } from "react-i18next";

const TipSection: FC<TipSectionProps> = ({ setShowTermsModal }) => {
  const { t } = useTranslation();

  const handleSubmitTip = (e: any) => {
    e.preventDefault();
    setShowTermsModal(true);
  };

  return (
    <section id="submit-tip" className="flex flex-col">
      <div
        className="bg-[#1D1B1B] h-[136px]"
        style={{
          clipPath: "polygon(0 0%, 100% 100%, 100% 100%, 0% 100%)",
        }}
      />

      <div className="bg-[#1D1B1B] flex flex-col-reverse lg:flex-row px-8 md:px-[70px] gap-4 py-10 lg:py-0 mt-[-1px]">
        <div>
          <h3 className="text-[52px] lg:text-[74px] text-white leading-[89.56px] font-[600] mb-2 lg:mb-[22px]">
            Unspokenn
          </h3>
          <h6 className="text-[40px] lg:text-[48px] text-white leading-[60.51px] font-[600]">
            {t("tipSectionTitle")}
          </h6>
          <p className="text-base text-white leading-[19.36px] font-[400] mt-[22px] max-w-[662px]">
            {t("tipSectionParagraph")}
          </p>
          <button
            onClick={handleSubmitTip}
            className="text-[18px] text-[#1D1B1B] leading-7 font-semibold bg-white mt-[38px] py-4 px-7 rounded-[100px]"
          >
            {t("submitTipBtn")}
          </button>
        </div>
        <img
          src={abuseImg}
          alt="abuse"
          className="w-full xs:w-[402px] xl:w-[549px]"
        />
      </div>
    </section>
  );
};

export default TipSection;

interface TipSectionProps {
  setShowTermsModal: (showTermsModal: boolean) => void;
}
